module.exports = __webpack_public_path__ + "img/auditCompleted.b351724e.png";